import { useSyncExternalStore } from 'react';
import { createPortal } from 'react-dom';

interface ModalPortalProps {
  children: React.ReactNode;
}

const emptySubscribe = () => () => {};

const ModalPortal = ({ children }: ModalPortalProps) => {
  const mounted = useSyncExternalStore(
    emptySubscribe,
    () => true,
    () => false
  );

  if (!mounted) return null;

  return createPortal(children, document.body);
};

export default ModalPortal;
